/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { BaseUser } from "src/classes/user";
import { JoinedMessage } from "src/components/Profile/JoinedMessage";
import { Avatar } from "src/components/Shared/User/Avatar";
import { Username } from "src/components/Shared/User/Username";

interface Props {
  user: BaseUser;
}

export default function AvatarAndName({ user }: Props) {
  return (
    <Wrapper id="cy-profile-avatar">
      <Avatar size={100} src={user.avatarURL(100)} />
      <Name>{user.snapshot.displayName}</Name>
      <UserDetails>
        <Username user={user} />
      </UserDetails>
      <JoinedMessage user={user} />
    </Wrapper>
  );
}

const Name = styled.div`
  margin-top: 10px;
  font-size: 24px;
  font-weight: 700;
`;

const Wrapper = styled.div``;

const UserDetails = styled.div``;
